import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Sidebar from "./components/Sidebar";
import ServiceGallery from "./components/ServiceGallery"
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
class PlayLanguageTherapy extends Component {
  render() {
    return (
      <div>
        {/* Navigation bar */}
        <NavBar />

        {/* breadcrumb */}
        {/*====================  breadcrumb area ====================*/}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>Play & Language Therapy</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href={`${process.env.PUBLIC_URL}/services`}>
                        Services
                      </a>
                    </li>
                    <li>Play & Language Therapy</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of breadcrumb area  ====================*/}

        <div className="page-wrapper section-space--inner--120">
          {/*Service section start*/}
          <div className="service-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-12 order-1 order-lg-2">
                  <div className="service-details">
                    {/* service gallery */}
                    <ServiceGallery />

                    <div className="content section-space--top--30">
                      <h2>Play & Language Therapy</h2>

                      <p>
                        Play and Language Therapy is a specialized intervention designed to enhance
                        children’s communication, language, social, emotional, and cognitive
                        development through structured play-based activities. It utilizes a child’s
                        natural interest in play to create meaningful opportunities for learning and
                        interaction. The therapy focuses on improving receptive language
                        (understanding), expressive language (speaking), vocabulary development,
                        articulation, social communication, attention, and problem-solving skills.
                      </p>

                      <p>
                        Therapists use a variety of techniques, including storytelling, role play,
                        games, songs, toys, picture cards, and interactive activities, to encourage
                        communication and language learning in a supportive environment. Play and
                        Language Therapy is particularly beneficial for children with speech and
                        language delays, autism spectrum disorder, developmental delays, learning
                        disabilities, hearing impairments, and social communication difficulties.
                      </p>

                      <p>
                        By integrating play with language-learning opportunities, this therapy
                        promotes effective communication, emotional expression, social participation,
                        and overall child development, helping children achieve greater independence
                        and success in daily life, school, and the community.
                      </p>

                      <div className="row">

                        <div className="col-lg-6 col-12 section-space--top--30">
                          <h3>Who Can Benefit?</h3>

                          <ul>
                            <li>Children with developmental delays</li>
                            <li>Autism Spectrum Disorder (ASD)</li>
                            <li>Cerebral Palsy</li>
                            <li>ADHD</li>
                            <li>Speech and language delays</li>
                            <li>Learning disabilities</li>
                          </ul>
                        </div>

                        <div className="col-lg-6 col-12 section-space--top--30">
                          <h3>Our Goals</h3>

                          <ul>
                            <li>Promote physical and cognitive development</li>
                            <li>Improve communication skills</li>
                            <li>Develop social and emotional abilities</li>
                            <li>Encourage independence</li>
                            <li>Prepare children for school and daily life</li>
                            <li>Support families through early guidance</li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-12 order-2 order-lg-1">
                  <Sidebar />
                </div>
              </div>
            </div>
          </div>
          {/*Service section end*/}
        </div>

        {/* Footer */}
        <Footer />

        {/* Mobile Menu */}
        <MobileMenu />
      </div>
    );
  }
}

export default PlayLanguageTherapy;
